import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LeadDetail from "./LeadDetail";
import LeadDeals from "./LeadDeals";
import LeadHistory from "./LeadHistory";
import LeadNotesHistory from "./LeadNotesHistory";
import LeadDbService from "../Services/LeadDbService";
import { toast, ToastContainer } from "react-toastify";
import { BsFire } from "react-icons/bs";
import useHotLeads from "../../hooks/useHotLeads";
import HotLeadHistoryModel from "../HotLeadComponent/HotLeadHistoryModel";
import { userRole } from '../../utils/storage'
import { getBasePathByUserRole } from "../../utils/roleRoutes";
import CustomHeading from "../common/CustomHeading";
import useScrollToTop from "../../hooks/useScrollToTop";
import { showInfoToast } from "../Constant/Notification";

const LeadInfo = () => {
  const navigate = useNavigate();
  const { leadId } = useParams();

  const [leadTeamName, setLeadTeamName] = useState("");
  const [leadUserName, setLeadUserName] = useState("");
  const [assignedUserId, setAssignedUserId] = useState("");

  const location = useLocation();

  const leadAssignStatus = location?.state?.assignStatus;
  const handleBack = () => {
    window.history.back();
  };

  const { handleLeadHotHistory, leadHotHistotyData, isOpen, setIsOpen } =
    useHotLeads();

  const handleReassign = () => {
    const path = getBasePathByUserRole()
    if(lead?.status === "Dealing" ||
      lead?.status === "Registered Client")
      {
        showInfoToast("Cannot reassign lead when it is in Dealing or Registered Client status.");
        return
      }
      else{
        navigate(`${path}/lead/reassign`, {
          state: {
            leadTeam: leadTeamName,
            teamId: lead?.teamId,
            leadUser: leadUserName,
            leadId: leadId,
            memberId : assignedUserId
           },
        });
    
      }
    
   
     
  };

  const path = userRole === "Admin" ? '/admin' : userRole === "CMO" ? '/cmo' : '/bod';

  const handelAssign = () => {
    navigate(`${path}/lead/reassign`, {
      state: {
        leadSourceId: lead?.leadSourceId,
        assignStatus: true,
        leadCount: 1,
        teamId: lead?.teamId,
        leadIds: [leadId],
      },
    });
  };

  const [lead, setLead] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await LeadDbService.fetchLeadById(leadId);
        console.log("Lead Data:", response.data);
        setLead(response.data);
        setLeadTeamName(response.data?.assignedTeam);
        setLeadUserName(response.data?.assignedUser);
        setAssignedUserId(response.data?.assignedUserId);
      } catch (error) {
        console.error("Error fetching lead data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("Lead data fetched", location?.state);

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message, {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
 
  useScrollToTop();

  return (
    <div className="bg-appGrayBackground  ">
       <AdminAppBar />
       <ToastContainer/>

      <div className="h-full  py-28  ">
        <div className="px-8 flex  pt-2  items-center ">
        
          <div className="flex justify-between w-full ">
          <CustomHeading title={"Lead Info"} isIcon={true} />


            <div className="flex items-center gap-4">
      { (userRole === "Admin" || userRole === "CMO")   &&   <div
                onClick={() => handleLeadHotHistory(leadId)}
                className="bg-white cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] font-medium s w-full rounded-[10px] p-2"
              >
                <BsFire className="text-xl" />
                <div>Hot Lead History</div>
              </div>}

              {console.log("Lead Info:", lead?.assignedUser)}
              {lead?.assignedUser != "Unassigned" && (
                <>
                  {(userRole === "Admin" || userRole === "CMO" || userRole === "BOD") && (
                    <button
                      onClick={handleReassign}
                      // disabled={
                      //   lead?.status === "Dealing" ||
                      //   lead?.status === "Registered Client"
                      // }
                      className={`h-10 ${
                        lead?.status === "Dealing" ||
                        lead?.status === "Registered Client"
                          ? "bg-gray-500 "
                          : "bg-customGreen "
                      } cursor-pointer text-white p-2 rounded-md mr-12`}
                    >
                      Reassign
                    </button>
                  )}
                </>
              )}

              {lead?.assignedUser === "Unassigned" && (
                <>
                {(userRole === "Admin" || userRole === "CMO" || userRole === "BOD") && (
                <button
                  onClick={handelAssign}
                  className={`h-10 ${
                    lead?.status === "Dealing"
                      ? "bg-gray-500"
                      : "bg-customGreen"
                  } cursor-pointer text-white p-2 rounded-md mr-12`}
                >
                  Assign
                </button>
                )}
                
                </>


              )}
            </div>
          </div>
        </div>

        <div className=" px-20 mt-4 flex gap-12 xl:gap-5 ">
          <div className="w-6/12">
            <LeadDetail lead={lead} />
          </div>
          <div className="flex flex-col w-6/12 gap-5">
            <LeadDeals docId={leadId} />
            <LeadHistory docId={leadId} />
            <LeadNotesHistory docId={leadId} />
          </div>
        </div>
      </div>
      <HotLeadHistoryModel
        isOpen={isOpen}
        selectedLeaddata={leadHotHistotyData}
        isClose={() => {
          setIsOpen(false);
        }}
      />
    </div>
  );
};

export default LeadInfo;
